


























































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import SalesPeriod from '@/views/statistic/SalesPeriod.vue';

// 할인/배송비재계산
@Component({
  components: { SalesPeriod },
  computed: {
    showResponsibleCheckbox() {
      this.responsibleObjectType;
    },
  },
})
export default class ComponentProductDetails extends Vue {
  //c
  @Prop({ required: true })
  private postPredict!: {};

  @Prop({ default: false })
  private escrowOrder!: boolean;

  @Prop({ default: true })
  private orgChargeDeliveryAmt!: boolean;

  @Prop({ default: false })
  private reSetData!: boolean;

  @Prop({ required: true })
  private displayedDeliveryAmtDiscountMessage!: boolean;

  @Prop({ required: true })
  private objJson!: string;

  @Prop({ default: '' })
  private pageName!: string;

  // FIXME: 이해할 순 없지만 일관성을 위해 default값에 nullable 하게함
  @Prop({ default: false })
  private responsibleObjectType!: 'BUYER' | 'SELLER';

  private chargeDeliveryAmt: boolean = false;
  private chargeDeliveryAmtDisabled: boolean = false;
  private modifyMode: boolean = false;
  private tooltipWrap: boolean = false;
  private cartCouponDiscountAmt: number = 0;
  private cancelCartCoupon: boolean = false;
  private cartCouponRestores: boolean = false;
  private cancelCartCouponName: string = '';
  private beforeDeliveryTotalDeliveryAmt: number = 0;
  private beforeDeliveryTotalDeliveryAmtLine: string = 'none';
  private afterDeliveryTotalDeliveryAmt: number = 0;
  private afterDeliveryTotalDeliveryAmtLine: string = 'none';
  private differenceOfTotalDeliveryAmt: number = 0;
  private differenceOfTotalDeliveryAmtLine: string = 'none';
  private orderDiscountAndDeliveryAmt: number = 0;
  private shippingNo: string = '';
  private ExchangeBeforeDeliveryTotalDeliveryAmt: number = 0;
  private ExchangeAfterDeliveryTotalDeliveryAmt: number = 0;
  private ExchangeDifferenceOfTotalDeliveryAmt: number = 0;
  private ExchangeShippingNo: string = '';
  private exchangeDeliveryDiv: boolean = false;
  private chargeDeliveryAmtDivFlg: boolean = false;

  private onClickDeliveryAmtInAdvanceHelp() {
    this.tooltipWrap = !this.tooltipWrap;
  }

  @Prop({ default: false })
  private modifyClaim!: boolean;

  private textDecoration = 'none';

  @Watch('postPredict')
  onPredictChange() {
    this.couponCalculation();
    this.deliveryCalculation();
    this.setResponsibleCheckboxData();
    if (this.escrowOrder && (this.$parent.$refs.componentItemsClaim as any).responsibleObjectTypeValue === 'SELLER') {
      this.textDecoration = 'line-through';
      this.chargeDeliveryAmtDivFlg = true;
      this.chargeDeliveryAmtDisabled = true;
    }
  }

  private mounted() {
    if (this.pageName !== 'CancelAllPopup') {
      this.couponCalculation();
      this.deliveryCalculation();
    }

    if (this.escrowOrder) {
      this.chargeDeliveryAmt = true;
      this.chargeDeliveryAmtDivFlg = true;
      this.chargeDeliveryAmtDisabled = true;
      this.textDecoration = 'line-through';
    }
  }

  private chargeDeliveryAmtChecked() {
    if (this.chargeDeliveryAmt) {
      this.textDecoration = 'line-through';
    } else {
      this.textDecoration = 'none';
    }
    if (this.pageName === 'CancelPopup' || this.pageName === 'CancelAllPopup') {
      this.$emit('setData', 'postPredict');
    } else {
      this.$emit('setData');
    }
  }

  private getDeliveryDifference(postPredict) {
    if (postPredict.amounts.refundDeliveryAmt !== 0 && postPredict.amounts.refundDeliveryAmt) {
      return postPredict.amounts.refundDeliveryAmt;
    }
    // 추가결제인 경우
    if (
      postPredict.amounts.before.delivery.totalDeliveryAmt <=
      postPredict.amounts.after.delivery.totalDeliveryAmt +
        (postPredict.amounts.returnDelivery?.prepaidProcessedDeliveryAmt || 0)
    ) {
      if (this.pageName === 'CancelPopup') {
        return postPredict.amounts.refund.delivery.totalDeliveryAmt;
      } else {
        return (
          postPredict.amounts.refund.delivery.totalDeliveryAmt -
          (postPredict.amounts.returnDelivery?.prepaidProcessedDeliveryAmt || 0)
        );
      }
    }
  }

  private couponCalculation() {
    if (this.pageName === 'ExchangePopupBefore' || this.pageName === 'ExchangePopupAfter') {
      this.cartCouponDiscountAmt = (this.postPredict as any).amounts.refund.coupon.cartCouponDiscountAmt * -1;
    } else {
      this.cartCouponDiscountAmt = (this.postPredict as any).amounts.refund.coupon.cartCouponDiscountAmt;
    }

    this.cancelCartCoupon =
      (this.postPredict as any).coupon &&
      (this.postPredict as any).coupon !== null &&
      (this.postPredict as any).coupon.cartCoupon != null;
    if (this.cancelCartCoupon) {
      this.cancelCartCouponName =
        this.$t('CLAIM_CANCELPOPUP_COUPON_NUMBER') +
        (this.postPredict as any).coupon.cartCoupon.couponNo.toString() +
        ' ' +
        (this.postPredict as any).coupon.cartCoupon.couponName +
        ')';
      this.cartCouponRestores = (this.postPredict as any).coupon.cartCoupon.restores;
    }
  }
  private deliveryCalculation() {
    switch (this.pageName) {
      case 'CancelAllPopup':
        this.beforeDeliveryTotalDeliveryAmt = (this.postPredict as any).amounts.before.delivery.totalDeliveryAmt;
        this.afterDeliveryTotalDeliveryAmt = (this.postPredict as any).amounts.after.delivery.totalDeliveryAmt;
        this.differenceOfTotalDeliveryAmt = this.beforeDeliveryTotalDeliveryAmt - this.afterDeliveryTotalDeliveryAmt;
        this.orderDiscountAndDeliveryAmt = this.cartCouponDiscountAmt * -1 + this.differenceOfTotalDeliveryAmt;
        this.shippingNo = '';
        break;

      case 'CancelPopup':
        this.beforeDeliveryTotalDeliveryAmt = (this
          .postPredict as any).amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt;
        this.beforeDeliveryTotalDeliveryAmtLine =
          (this.postPredict as any).amounts.before.delivery.deliveryGroupAmounts.alreadyPaidTotalDeliveryAmt !==
            (this.postPredict as any).amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt &&
          (this.postPredict as any).shipping.prepaid === true
            ? 'line-through'
            : 'none';
        this.afterDeliveryTotalDeliveryAmt = (this
          .postPredict as any).amounts.after.delivery.deliveryGroupAmounts.totalDeliveryAmt;
        this.differenceOfTotalDeliveryAmt = this.getDeliveryDifference(this.postPredict) || 0;
        this.orderDiscountAndDeliveryAmt =
          this.cartCouponDiscountAmt * -1 +
          this.differenceOfTotalDeliveryAmt +
          (this.postPredict as any).amounts.deliveryAdjustAmt;
        this.shippingNo =
          this.$t('CLAIM_CANCELPOPUP_SHIPPINGNUMBER') + ':' + (this.postPredict as any).shipping.shippingNo;
        break;

      case 'ReturnPopup':
        this.beforeDeliveryTotalDeliveryAmt = (this
          .postPredict as any).amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt;
        this.beforeDeliveryTotalDeliveryAmtLine =
          (this.postPredict as any).amounts.before.delivery.deliveryGroupAmounts.alreadyPaidTotalDeliveryAmt !==
            (this.postPredict as any).amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt &&
          (this.postPredict as any).shipping.prepaid === true
            ? 'line-through'
            : 'none';
        this.afterDeliveryTotalDeliveryAmt =
          (this.postPredict as any).amounts.after.delivery.deliveryGroupAmounts.totalDeliveryAmt +
          (this.postPredict as any).amounts.returnDelivery?.processedDeliveryAmt;
        this.differenceOfTotalDeliveryAmt = this.getDeliveryDifference(this.postPredict) || 0;
				// 할인/배송비재계산 > 재계산합계 = 할임금액변경 + 배송비변경
        this.orderDiscountAndDeliveryAmt =
          this.cartCouponDiscountAmt * -1 +
          this.differenceOfTotalDeliveryAmt;
        this.shippingNo =
          this.$t('CLAIM_CANCELPOPUP_SHIPPINGNUMBER') + ':' + (this.postPredict as any).shipping.shippingNo;
        break;

      case 'ExchangePopupBefore':
        if (
          (this.postPredict as any).amounts.exchangeDelivery !== undefined &&
          (this.postPredict as any).amounts.exchangeDelivery !== null
        ) {
          this.exchangeDeliveryDiv = true;
          this.beforeDeliveryTotalDeliveryAmt = (this
            .postPredict as any).amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt;
          this.afterDeliveryTotalDeliveryAmt =
            (this.postPredict as any).amounts.after.delivery.deliveryGroupAmounts.totalDeliveryAmt +
            ((this.postPredict as any).amounts.returnDelivery?.totalDeliveryAmt || 0);
          this.differenceOfTotalDeliveryAmt = this.getDeliveryDifference(this.postPredict) * -1 || 0;
          this.shippingNo =
            this.$t('CLAIM_CANCELPOPUP_SHIPPINGNUMBER') + ':' + (this.postPredict as any).shipping.shippingNo;
          this.ExchangeBeforeDeliveryTotalDeliveryAmt = 0;
          this.ExchangeAfterDeliveryTotalDeliveryAmt = (this
            .postPredict as any).amounts.exchangeDelivery.totalDeliveryAmt;
          this.ExchangeDifferenceOfTotalDeliveryAmt = (this
            .postPredict as any).amounts.exchangeDelivery.totalPrepaidDeliveryAmt;
          this.ExchangeShippingNo = this.$t('CLAIM_CANCELPOPUP_SHIPPINGNUMBER') + ': 신규';
          this.orderDiscountAndDeliveryAmt =
            this.cartCouponDiscountAmt * -1 +
            this.differenceOfTotalDeliveryAmt +
            this.ExchangeDifferenceOfTotalDeliveryAmt;
        } else {
          this.exchangeDeliveryDiv = false;
          this.beforeDeliveryTotalDeliveryAmt = (this
            .postPredict as any).amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt;
          this.afterDeliveryTotalDeliveryAmt =
            (this.postPredict as any).amounts.after.delivery.deliveryGroupAmounts.totalDeliveryAmt +
            ((this.postPredict as any).amounts.returnDelivery?.totalDeliveryAmt || 0);
          this.differenceOfTotalDeliveryAmt = this.getDeliveryDifference(this.postPredict) * -1 || 0;
          this.shippingNo =
            this.$t('CLAIM_CANCELPOPUP_SHIPPINGNUMBER') + ':' + (this.postPredict as any).shipping.shippingNo;
          this.orderDiscountAndDeliveryAmt = this.cartCouponDiscountAmt * -1 + this.differenceOfTotalDeliveryAmt;
        }
        break;

      case 'ExchangePopupAfter':
        this.beforeDeliveryTotalDeliveryAmt = (this
          .postPredict as any).amounts.before.delivery.deliveryGroupAmounts.totalDeliveryAmt;
        this.afterDeliveryTotalDeliveryAmt =
          (this.postPredict as any).amounts.after.delivery.deliveryGroupAmounts.totalDeliveryAmt +
          ((this.postPredict as any).amounts.returnDelivery?.processedDeliveryAmt || 0);
        this.differenceOfTotalDeliveryAmt = this.getDeliveryDifference(this.postPredict) * -1 || 0;
        this.shippingNo =
          this.$t('CLAIM_CANCELPOPUP_SHIPPINGNUMBER') + ':' + (this.postPredict as any).shipping.shippingNo;
        this.orderDiscountAndDeliveryAmt = this.cartCouponDiscountAmt * -1 + this.differenceOfTotalDeliveryAmt;
        break;
    }
  }

  private setResponsibleCheckboxData() {
    this.chargeDeliveryAmtDivFlg =
      (this.$parent.$refs.componentItemsClaim as any).responsibleObjectTypeValue === 'SELLER';
    if (this.chargeDeliveryAmt && this.chargeDeliveryAmtDivFlg && this.differenceOfTotalDeliveryAmt < 0) {
      this.differenceOfTotalDeliveryAmtLine = 'line-through';
    } else {
      this.differenceOfTotalDeliveryAmtLine = 'none';
    }
    if (
      this.chargeDeliveryAmt &&
      this.chargeDeliveryAmtDivFlg &&
      (this.postPredict as any).amounts.returnDelivery?.processedDeliveryAmt > 0
    ) {
      this.afterDeliveryTotalDeliveryAmtLine = 'line-through';
    } else {
      this.afterDeliveryTotalDeliveryAmtLine = 'none';
    }
  }
}
